module.exports = __webpack_public_path__ + "static/media/DF5C8559-6144-4FAF-80CA-0EECA39B587B_Small.126c8666.jpg";